var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("span", [_vm._v("在岗人数：")]),
          _c("span", { attrs: { id: "realOnDutyCount" } }),
        ]),
        _c("div", { staticClass: "row" }, [
          _c("span", [_vm._v("应在岗人数：")]),
          _c("span", { attrs: { id: "mustOnDutyCount" } }),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }